
const Dashboard = () => {
  
    return (
        <>
            <div className="h-[90vh] flex items-center justify-center relative overflow-hidden">
                <div className="absolute w-72 h-72 bg-blue-200 rounded-full bottom-10 left-10 opacity-30"></div>
                <div className="absolute w-72 h-72 bg-red-200 rounded-full top-10 right-10 opacity-30"></div>
                <div className="p-10 w-[800px] text-center">
                    <h1 className="text-5xl font-bold text-gray-800 mb-8">
                        Welcome Back
                    </h1>
                    <div className="flex justify-center mb-4">
                        <img
                            src="./main-logo.png"
                            alt="Logo"
                            style={{ height: "100px", objectFit: "contain" }}
                        />
                    </div>
                    
                </div>
            </div>


        </>
    );
}

export default Dashboard;